<div class="container">
  <div class="row">
    <div class="card full-width-card">
      <div class="card-body">
        <section>
          <h1 class="section-header">{{'CHANGE_SECURITY_QUES' | globalTranslate }}</h1><hr>
          <p [innerHtml]="'CHANGE_SECURITY_TEXT' | globalTranslate"></p><br>

          <form [formGroup]="updateSecurityQuestions">
          <div class="row">
            <div class="col">
              <nh-field [isRow]="true" label="{{'Q1' | globalTranslate }}" class="label-section">
                <select class="zoom-friendly-select" nhTranslate name="question1" formControlName="question1" [items]="questionSet1"
                  [attr.aria-label]="'Q1' | globalTranslate" required aria-required="true"></select>
              </nh-field>
            </div>
          </div>
            <div class="row">
              <div class="col-12">
                <nh-field [isRow]="true" label="{{'ANSWER' | globalTranslate }}" class="label-section">
                  <input type="text" name="answer1" formControlName="answer1" aria-label="answer1" maxlength="40"
                    (input)="answerUpdate(answer2, answer3, answer1)" class="form-control" required>
                </nh-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <nh-field [isRow]="true" label="{{'Q2' | globalTranslate }}" class="label-section">
                  <select  class="zoom-friendly-select" nhTranslate name="question2" formControlName="question2" [items]="questionSet2" [attr.aria-label]="'Q2' | globalTranslate" required aria-required="true"></select>
                </nh-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <nh-field [isRow]="true" label="{{'ANSWER' | globalTranslate }}" class="label-section">
                  <input type="text" name="answer2" formControlName="answer2" aria-label="answer2" maxlength="40"
                    (input)="answerUpdate(answer1, answer3, answer2)" class="form-control" required>
                </nh-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <nh-field [isRow]="true" label="{{'Q3' | globalTranslate }}" class="label-section">
                  <select   class="zoom-friendly-select" nhTranslate name="question3" formControlName="question3" [items]="questionSet3" [attr.aria-label]="'Q3' | globalTranslate" required aria-required="true"></select>
                </nh-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <nh-field [isRow]="true" label="{{'ANSWER' | globalTranslate }}" class="label-section">
                  <input type="text" name="answer3" formControlName="answer3" aria-label="answer3" maxlength="40"
                    (input)="answerUpdate(answer1, answer2, answer3)" class="form-control" required>
                </nh-field>
              </div>
            </div>
          </form>
        </section>
      </div>
    </div>
  </div>
</div>
